import type { NativeAppPlatform } from './app-version.constants';

/** Public store listings of the native app, shared by the smart banner and the force-update sheet. */
export const APP_STORE_URLS: Record<NativeAppPlatform, string> = {
	ios: 'https://apps.apple.com/app/id6753768969',
	android: 'https://play.google.com/store/apps/details?id=com.sportspredict',
};
